import React, {Component} from 'react';
import './AboutCard.css';
import {Link} from 'react-router-dom';
import {Avatar} from '../widgets';

class AboutCard extends Component {
	render() {
		const {
			provider: {
				profession,
				premium,
				user: {
					firstname,
					lastname,
					location: {suburb}
				},
				profile: {
					brief,
					avatarUrl,
					uniqueName,
					avatarPosition = 33,
					backgroundPosition = 33,
					backgroundImage
				}
			}
		} = this.props;

		return (
			<Link to={`/@${uniqueName}`} className="AboutCard">
				<Avatar className="AboutCard-avatar" provider={this.props.provider} size={48} />
				<div className="AboutCard-details">
					<div className="AboutCard-name">
						{firstname} {lastname}
					</div>
					<p className="AboutCard-profession">{profession}</p>
					<div className="AboutCard-geo">
						<span className="icon icon-room" />
						<span className="AboutCard-suburb">{suburb}</span>
					</div>
				</div>
			</Link>
		);
	}
}

export default AboutCard;



// WEBPACK FOOTER //
// ./src/profile/AboutCard.js